import { render, staticRenderFns } from "./OddTable.vue?vue&type=template&id=fafd3e9a&"
import script from "./OddTable.vue?vue&type=script&lang=js&"
export * from "./OddTable.vue?vue&type=script&lang=js&"
import style0 from "./OddTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports